export interface AnalyticsEvent {
  name: string;
  category?: string;
  properties?: Record<string, unknown>;
}

function generateEventId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function trackEvent(event: AnalyticsEvent): string {
  const enrichedEvent = {
    id: generateEventId(),
    timestamp: new Date().toISOString(),
    ...event
  };

  if (typeof window !== 'undefined' && typeof CustomEvent !== 'undefined') {
    const customEvent = new CustomEvent('analytics:event', { detail: enrichedEvent });
    window.dispatchEvent(customEvent);
  }

  if (import.meta.env.DEV) {
    console.debug('[analytics]', enrichedEvent);
  }

  return enrichedEvent.id;
}
